webpackJsonp([6],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	/**
	 * Created by jv on 24/04/2017.
	 */
	//js
	var Shared = __webpack_require__(115);
	var StoreShared = __webpack_require__(163);
	var LanguageManager = __webpack_require__(5);
	var utils = __webpack_require__(3);
	var UserTypeSelectionTemplate = __webpack_require__(397);
	var StoreServices = __webpack_require__(162);
	var StorageController = __webpack_require__(123);
	
	//Styles (Load module specific style after js - some modules (shared.js in this case) contain global css)
	// --> order of require calls matters!!
	__webpack_require__(661);
	
	$(function () {
	  //Initialze stuff
	  LanguageManager.init(function () {
	    StoreShared.init(function () {
	      userTypeSelection.init();
	    }, true);
	  }, Shared.defaultLocale);
	});
	
	var userTypeSelection = {};
	
	(function (UserTypeSelection) {
	  var catalogs;
	
	  var utsTemplate;
	
	  UserTypeSelection.init = function () {
	    getCatalogs(function () {
	      setUpUserTypeSelection();
	
	      setUpContinueBtn();
	    });
	  };
	
	  function setUpUserTypeSelection() {
	    utsTemplate = new UserTypeSelectionTemplate({
	      appendTo: $("#user-selection-wrapper"),
	      userTypes: getUserTypesFromCatalogs(),
	      onCountrySelected: function onCountrySelected(country) {
	        utils.devLog(country);
	        if (utils.isNotNull(utsTemplate.selectedUserType)) {
	          $("#continue-btn").show();
	        } else {
	          $("#continue-btn").hide();
	        }
	      },
	      onUserTypeSelected: function onUserTypeSelected(userType) {
	        utils.devLog(userType);
	        if (utils.isNotNull(userType)) {
	          $("#continue-btn").show();
	        } else {
	          $("#continue-btn").hide();
	        }
	      }
	    });
	  }
	
	  function getUserTypesFromCatalogs() {
	    var countries = [];
	    var countryKeys = [];
	
	    for (var i = 0; i < catalogs.length; i++) {
	      if ($.inArray(catalogs[i].locale, countryKeys) === -1) {
	        countryKeys.push(catalogs[i].locale);
	
	        countries.push({
	          locale: catalogs[i].locale,
	          displayText: StoreShared.getReadableLocale(catalogs[i].locale),
	          userTypes: []
	        });
	      }
	    }
	
	    for (var x = 0; x < countries.length; x++) {
	      for (var y = 0; y < catalogs.length; y++) {
	        if (catalogs[y].locale === countries[x].locale) {
	          countries[x].userTypes.push({
	            key: catalogs[y].type,
	            displayText: StoreShared.getReadableUserType(catalogs[y].type),
	            locale: catalogs[y].locale,
	            infoUrl: catalogs[y]["info-url"],
	            catalogUrl: catalogs[y]["catalog-url"]
	          });
	        }
	      }
	    }
	
	    return countries;
	  }
	
	  function setUpContinueBtn() {
	    $("#continue-btn").on("click", function (e) {
	      if (utils.isNotNull(utsTemplate.selectedUserType)) {
	        // var currentUserLocale = StorageController.getFromLocal(StorageController.keys.STORE_USER_LOCALE);
	        // var currentUserType = StorageController.getFromLocal(StorageController.keys.STORE_USER_TYPE);
	        //
	        // if(StoreShared.sessionData.cart.itemCount > 0 && (utsTemplate.selectedUserType.locale !== currentUserLocale || utsTemplate.selectedUserType.key !== currentUserType))
	        // {
	        //   Shared.Dialog.showYesNoDialog("store.change_user_type.confirmation.title", "store.change_user_type.confirmation.text", function()
	        //   {
	        //     goToStoreInfo(utsTemplate.selectedUserType);
	        //   });
	        // }
	        // else
	        // {
	        //   goToStoreInfo(utsTemplate.selectedUserType);
	        // }
	
	        goToStoreInfo(utsTemplate.selectedUserType);
	      }
	    });
	  }
	
	  function goToStoreInfo(userType) {
	    utils.devLog(userType);
	
	    StorageController.saveToLocal(StorageController.keys.STORE_USER_LOCALE, userType.locale);
	    StorageController.saveToLocal(StorageController.keys.STORE_USER_TYPE, userType.key);
	
	    if (utils.isNotNull(userType.infoUrl)) {
	      utils.redirect(userType.infoUrl);
	    } else {
	      utils.redirect(userType.catalogUrl);
	    }
	  }
	
	  function getCatalogs(callback) {
	    StoreServices.getCatalogList(function (data) {
	      // Success
	      catalogs = data;
	
	      utils.devLog("Catalogs: %o", catalogs);
	
	      if (utils.isFunction(callback)) {
	        callback();
	      }
	    }, function (data) {
	      // Fail
	      Shared.Dialog.showMessageDialog(data.readableErrorTitle, data.readableErrorMessage);
	      console.error("Failed to get catalog list");
	    });
	  }
	})(userTypeSelection);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 116:
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./nl-BE.json": 117
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 116;


/***/ }),

/***/ 120:
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 6,
		"./af.js": 6,
		"./ar": 12,
		"./ar-dz": 7,
		"./ar-dz.js": 7,
		"./ar-ly": 8,
		"./ar-ly.js": 8,
		"./ar-ma": 9,
		"./ar-ma.js": 9,
		"./ar-sa": 10,
		"./ar-sa.js": 10,
		"./ar-tn": 11,
		"./ar-tn.js": 11,
		"./ar.js": 12,
		"./az": 13,
		"./az.js": 13,
		"./be": 14,
		"./be.js": 14,
		"./bg": 15,
		"./bg.js": 15,
		"./bn": 16,
		"./bn.js": 16,
		"./bo": 17,
		"./bo.js": 17,
		"./br": 18,
		"./br.js": 18,
		"./bs": 19,
		"./bs.js": 19,
		"./ca": 20,
		"./ca.js": 20,
		"./cs": 21,
		"./cs.js": 21,
		"./cv": 22,
		"./cv.js": 22,
		"./cy": 23,
		"./cy.js": 23,
		"./da": 24,
		"./da.js": 24,
		"./de": 26,
		"./de-at": 25,
		"./de-at.js": 25,
		"./de.js": 26,
		"./dv": 27,
		"./dv.js": 27,
		"./el": 28,
		"./el.js": 28,
		"./en-au": 29,
		"./en-au.js": 29,
		"./en-ca": 30,
		"./en-ca.js": 30,
		"./en-gb": 31,
		"./en-gb.js": 31,
		"./en-ie": 32,
		"./en-ie.js": 32,
		"./en-nz": 33,
		"./en-nz.js": 33,
		"./eo": 34,
		"./eo.js": 34,
		"./es": 36,
		"./es-do": 35,
		"./es-do.js": 35,
		"./es.js": 36,
		"./et": 37,
		"./et.js": 37,
		"./eu": 38,
		"./eu.js": 38,
		"./fa": 39,
		"./fa.js": 39,
		"./fi": 40,
		"./fi.js": 40,
		"./fo": 41,
		"./fo.js": 41,
		"./fr": 44,
		"./fr-ca": 42,
		"./fr-ca.js": 42,
		"./fr-ch": 43,
		"./fr-ch.js": 43,
		"./fr.js": 44,
		"./fy": 45,
		"./fy.js": 45,
		"./gd": 46,
		"./gd.js": 46,
		"./gl": 47,
		"./gl.js": 47,
		"./he": 48,
		"./he.js": 48,
		"./hi": 49,
		"./hi.js": 49,
		"./hr": 50,
		"./hr.js": 50,
		"./hu": 51,
		"./hu.js": 51,
		"./hy-am": 52,
		"./hy-am.js": 52,
		"./id": 53,
		"./id.js": 53,
		"./is": 54,
		"./is.js": 54,
		"./it": 55,
		"./it.js": 55,
		"./ja": 56,
		"./ja.js": 56,
		"./jv": 57,
		"./jv.js": 57,
		"./ka": 58,
		"./ka.js": 58,
		"./kk": 59,
		"./kk.js": 59,
		"./km": 60,
		"./km.js": 60,
		"./ko": 61,
		"./ko.js": 61,
		"./ky": 62,
		"./ky.js": 62,
		"./lb": 63,
		"./lb.js": 63,
		"./lo": 64,
		"./lo.js": 64,
		"./lt": 65,
		"./lt.js": 65,
		"./lv": 66,
		"./lv.js": 66,
		"./me": 67,
		"./me.js": 67,
		"./mi": 68,
		"./mi.js": 68,
		"./mk": 69,
		"./mk.js": 69,
		"./ml": 70,
		"./ml.js": 70,
		"./mr": 71,
		"./mr.js": 71,
		"./ms": 73,
		"./ms-my": 72,
		"./ms-my.js": 72,
		"./ms.js": 73,
		"./my": 74,
		"./my.js": 74,
		"./nb": 75,
		"./nb.js": 75,
		"./ne": 76,
		"./ne.js": 76,
		"./nl": 78,
		"./nl-be": 77,
		"./nl-be.js": 77,
		"./nl.js": 78,
		"./nn": 79,
		"./nn.js": 79,
		"./pa-in": 80,
		"./pa-in.js": 80,
		"./pl": 81,
		"./pl.js": 81,
		"./pt": 83,
		"./pt-br": 82,
		"./pt-br.js": 82,
		"./pt.js": 83,
		"./ro": 84,
		"./ro.js": 84,
		"./ru": 85,
		"./ru.js": 85,
		"./se": 86,
		"./se.js": 86,
		"./si": 87,
		"./si.js": 87,
		"./sk": 88,
		"./sk.js": 88,
		"./sl": 89,
		"./sl.js": 89,
		"./sq": 90,
		"./sq.js": 90,
		"./sr": 92,
		"./sr-cyrl": 91,
		"./sr-cyrl.js": 91,
		"./sr.js": 92,
		"./ss": 93,
		"./ss.js": 93,
		"./sv": 94,
		"./sv.js": 94,
		"./sw": 95,
		"./sw.js": 95,
		"./ta": 96,
		"./ta.js": 96,
		"./te": 97,
		"./te.js": 97,
		"./tet": 98,
		"./tet.js": 98,
		"./th": 99,
		"./th.js": 99,
		"./tl-ph": 100,
		"./tl-ph.js": 100,
		"./tlh": 101,
		"./tlh.js": 101,
		"./tr": 102,
		"./tr.js": 102,
		"./tzl": 103,
		"./tzl.js": 103,
		"./tzm": 105,
		"./tzm-latn": 104,
		"./tzm-latn.js": 104,
		"./tzm.js": 105,
		"./uk": 106,
		"./uk.js": 106,
		"./uz": 107,
		"./uz.js": 107,
		"./vi": 108,
		"./vi.js": 108,
		"./x-pseudo": 109,
		"./x-pseudo.js": 109,
		"./yo": 110,
		"./yo.js": 110,
		"./zh-cn": 111,
		"./zh-cn.js": 111,
		"./zh-hk": 112,
		"./zh-hk.js": 112,
		"./zh-tw": 113,
		"./zh-tw.js": 113
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 120;


/***/ }),

/***/ 397:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {"use strict";
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Created by jv on 07/04/2017.
	 */
	var utils = __webpack_require__(3);
	var LanguageManager = __webpack_require__(5);
	
	__webpack_require__(621);
	
	module.exports = function () {
	  function UserTypeSelectionTemplate(options) {
	    _classCallCheck(this, UserTypeSelectionTemplate);
	
	    if (utils.isNull(options)) {
	      throw "options must be defined";
	    }
	
	    this.appendTo = $(options.appendTo);
	
	    this.userTypes = utils.isArray(options.userTypes) ? options.userTypes : [];
	
	    this.selectedCountry = null;
	    this.selectedUserType = null;
	
	    this.onCountrySelected = options.onCountrySelected;
	    this.onUserTypeSelected = options.onUserTypeSelected;
	    this.onRender = options.onRender;
	    this.afterRender = options.afterRender;
	
	    this.userSelectionWrapper = null;
	    this.countryWrapper = null;
	    this.userTypeWrapper = null;
	
	    this.create();
	
	    utils.devLog(this.userTypes);
	  }
	
	  _createClass(UserTypeSelectionTemplate, [{
	    key: "create",
	    value: function create() {
	      if (this._initialized !== true) {
	        this.userSelectionWrapper = $("<div class='user-selection-wrapper clearfix'></div>");
	        this.countryWrapper = $("<div class='country-wrapper'></div>").appendTo(this.userSelectionWrapper);
	        this.userTypeWrapper = $("<div class='user-type-wrapper'></div>").appendTo(this.userSelectionWrapper);
	
	        this.appendTo.append(this.userSelectionWrapper);
	
	        this.rerender();
	
	        this._initialized = true;
	      }
	    }
	  }, {
	    key: "destroy",
	    value: function destroy() {
	      if (utils.isNotNull(this.userSelectionWrapper) && this.userSelectionWrapper.length) {
	        this.userSelectionWrapper.remove();
	      }
	
	      this._initialized = false;
	    }
	  }, {
	    key: "show",
	    value: function show() {
	      if (utils.isNotNull(this.userSelectionWrapper) && this.userSelectionWrapper.length) {
	        this.userSelectionWrapper.show();
	      }
	    }
	  }, {
	    key: "hide",
	    value: function hide() {
	      if (utils.isNotNull(this.userSelectionWrapper) && this.userSelectionWrapper.length) {
	        this.userSelectionWrapper.hide();
	      }
	    }
	  }, {
	    key: "rerender",
	    value: function rerender() {
	      this.renderUserTypeWrapper();
	    }
	  }, {
	    key: "renderUserTypeWrapper",
	    value: function renderUserTypeWrapper() {
	      this.renderCountrySelection();
	      this.renderUserTypeSelection();
	    }
	  }, {
	    key: "renderCountrySelection",
	    value: function renderCountrySelection() {
	      var that = this;
	
	      this.countryWrapper.empty();
	      this.countryWrapper.append("<h4 class='subtitle center-text'>" + LanguageManager.getValueForKey("store.user_type_selection.countries.title"));
	
	      var countrySelectionEl = $("<div class='countries clearfix'></div>");
	
	      for (var i = 0; i < this.userTypes.length; i++) {
	        var countryOption = this.userTypes[i];
	        countrySelectionEl.append("<div class='country-option' data-locale='" + countryOption.locale + "'><div class='logo'><span class='flag flag-" + countryOption.locale + "'></span></div><div class='country-text'>" + countryOption.displayText + "</div></div>");
	      }
	
	      countrySelectionEl.find(".country-option").on("click", function (e) {
	        countrySelectionEl.find(".country-option").removeClass("selected");
	
	        var $this = $(this);
	        $this.addClass("selected");
	        var localeSelected = $this.attr("data-locale");
	
	        that.selectedUserType = null;
	
	        for (var i = 0; i < that.userTypes.length; i++) {
	          if (that.userTypes[i].locale === localeSelected) {
	            that.selectedCountry = that.userTypes[i];
	            break;
	          }
	        }
	
	        that.renderUserTypeSelection();
	
	        if (utils.isFunction(that.onCountrySelected)) {
	          that.onCountrySelected(that.selectedCountry);
	        }
	      });
	
	      this.countryWrapper.append(countrySelectionEl);
	    }
	  }, {
	    key: "renderUserTypeSelection",
	    value: function renderUserTypeSelection() {
	      if (utils.isNotNull(this.selectedCountry)) {
	        var that = this;
	
	        this.userTypeWrapper.empty();
	
	        this.userTypeWrapper.append("<h4 class='subtitle center-text'>" + LanguageManager.getValueForKey("store.user_type_selection.user_types.title"));
	
	        var userTypesEl = $("<div class='user-types clearfix'></div>");
	
	        for (var i = 0; i < this.selectedCountry.userTypes.length; i++) {
	          var userType = this.selectedCountry.userTypes[i];
	          userTypesEl.append("<div class='user-type' data-user-type='" + userType.key + "'><div class='logo'><span class='user-type-logo user-type-" + userType.key.toLowerCase() + "'</span></div><div class='user-type-text'>" + userType.displayText + "</div></div>");
	        }
	
	        userTypesEl.find(".user-type").on("click", function (e) {
	          userTypesEl.find(".user-type").removeClass("selected");
	
	          var $this = $(this);
	          $this.addClass("selected");
	          var userTypeSelected = $this.attr("data-user-type");
	
	          for (var i = 0; i < that.selectedCountry.userTypes.length; i++) {
	            var userType = that.selectedCountry.userTypes[i];
	            if (userType.key === userTypeSelected) {
	              that.selectedUserType = userType;
	              break;
	            }
	          }
	
	          if (utils.isFunction(that.onUserTypeSelected)) {
	            that.onUserTypeSelected(that.selectedUserType);
	          }
	        });
	
	        this.userTypeWrapper.append(userTypesEl);
	      }
	    }
	  }]);
	
	  return UserTypeSelectionTemplate;
	}();
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),

/***/ 621:
259,

/***/ 661:
259

});


// WEBPACK FOOTER //
// js/user-type-selection.3eee03d7630969d626c0.js